export default {"src":"/_next/static/media/Mastercard.6c9263af.svg","height":24,"width":40};